import React, { useMemo } from 'react';
import classNames from 'classnames';
import { School } from 'models/School';
import { useTranslation } from 'react-i18next';
import { Button } from 'ncoded-component-library';
import { ReactComponent as DuplicateIcon } from 'icons/Duplicate.icon.svg';
import env from 'env';
import useAppDispatch from 'hooks/useAppDispatch';
import { popSuccess } from 'store/slices/popNotifications.slice';
import { VacancyStatus } from 'searchality-data';

import './JobPreviewHero.styles.scss';
import './JobPreviewHero.styles.responsive.scss';

type JobPreviewHeroProps = {
  className?: string;
  data: {
    positionTitle: string;
    isFullTimeEmployment: boolean;
    schools: School[];
    _id: string;
    status: VacancyStatus;
  };
};

const JobPreviewHero: React.FC<JobPreviewHeroProps> = (props) => {
  const { className, data } = props;

  const { positionTitle, isFullTimeEmployment, schools, status } = data || {};

  const { t } = useTranslation();

  const dispatch = useAppDispatch();

  const baseClass = 'job-preview-hero';
  const classes = classNames(baseClass, className);

  const employementType = useMemo(
    () =>
      isFullTimeEmployment ? t('fullTimePosition') : t('partTimePosition'),
    [isFullTimeEmployment, t],
  );

  const jobSchools = useMemo(
    () => schools?.map(({ name }) => name).join(', '),
    [schools],
  );

  return (
    <div className={classes}>
      <h1 className={`${baseClass}__title`}>{positionTitle}</h1>
      <div className={`${baseClass}__job-information`}>
        <p className={`${baseClass}__job-information__schools`}>{jobSchools}</p>
        <p className={`${baseClass}__job-information__employement-type`}>
          {employementType}
        </p>
      </div>
      {!!data._id &&
        (status === VacancyStatus.PUBLISHED ||
          status === VacancyStatus.ONGOING) && (
          <div className={`${baseClass}__action-buttons`}>
            <Button
              onClick={() => {
                navigator.clipboard.writeText(
                  `${env.PLATFORM_ENDPOINT}/job-application/${data._id}`,
                );
                dispatch(popSuccess(t('copyToClipboardSuccess')));
              }}
              icon={<DuplicateIcon />}
              iconPosition="right"
              variant="outline"
            >
              {t('copyLink')}
            </Button>
          </div>
        )}
      <div className={`${baseClass}__circle`} />
    </div>
  );
};

export default JobPreviewHero;
